module.exports = "<div class=\"vrm-upload\">\n    <input type=\"file\" accept=\"{{getAcceptedMIME()}}\">\n    <ng-transclude/>\n</div>\n";